// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1K9CL","cell":"ColumnAccessor_cell__3icDF","firstCellAccent":"ColumnAccessor_firstCellAccent__1aKKn"};